import React, { useMemo, useState } from "react";
import { connect } from "react-redux";
import {
  Alert,
  Box,
  InputAdornment,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";

import { updateOrgAccount } from "./../../../../store/actions";

const SUPPORT_EMAIL = "support.cloudcatcher@cloudnovatech.com";

const ComplianceAddons = (props) => {
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [search, setSearch] = useState("");

  console.log("props.editAccount: ", props.editAccount);

  let complianceColumns = [
    {
      field: "name",
      headerName: "Name",
      width: 200,
    },
    // ...(props.editAccount.subscription_type.toLowerCase().includes("trial")
    //   ? [] // If it's "Trial", exclude the price column
    //   : [
    //       {
    //         field: "price",
    //         headerName: (
    //           <div
    //             style={{
    //               display: "flex",
    //               flexDirection: "row",
    //               alignItems: "center",
    //             }}
    //           >
    //             Price&nbsp;
    //             <small style={{ color: "red", fontSize: "smaller" }}>
    //               (Billed Monthly)
    //             </small>
    //           </div>
    //         ),
    //         width: 200,
    //         valueFormatter: (params) => `$${params.value || "0.00"}`,
    //       },
    //     ]),
    {
      field: "description",
      headerName: "Description",
      width: 500,
    },
  ];

  if (props.orgLicensing.data.licenseName === "AwsMarketPlaceLicense") {
    complianceColumns = complianceColumns.filter(
      (column) => column.field !== "price"
    );
  }

  let complianceRows = [];
  if (props.complianceAddOns) {
    complianceRows = props.complianceAddOns.map((addOn, index) => ({
      id: index + 1,
      name: addOn.name,
      price: addOn.price,
      description: addOn.description,
      enabled: addOn.enabled,
    }));
  }

  useState(() => {
    const alreadySelectedRows = complianceRows
      .filter((addOn) => addOn.enabled)
      .map((addOn) => addOn.id);
    setRowSelectionModel([...alreadySelectedRows]);
  }, []);

  const filteredRows = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return complianceRows;
    return complianceRows.filter(
      (row) =>
        (row.name || "").toLowerCase().includes(q) ||
        (row.description || "").toLowerCase().includes(q)
    );
  }, [complianceRows, search]);

  return (
    <Box
      sx={{
        width: "100%",
        ...(props.isAzureAccount && {
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }),
      }}
    >
      <Alert
        variant="outlined"
        severity="info"
        icon={false}
        sx={{
          alignItems: "center",
          "& .MuiAlert-message": { flex: 1, py: 0.75 },
          "& .MuiAlert-action": { pt: 0, mr: 0, alignItems: "center" },
        }}
        action={
          <TextField
            size="small"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" sx={{ color: "rgba(0,0,0,0.45)" }} />
                </InputAdornment>
              ),
            }}
            sx={{
              minWidth: { xs: 140, sm: 200 },
              bgcolor: "#fff",
              "& .MuiOutlinedInput-root": {
                height: 36,
                fontSize: "0.875rem",
              },
            }}
          />
        }
      >
        Compliance Standards
      </Alert>
      <Box sx={props.isAzureAccount ? { flex: 1, minHeight: 0 } : undefined}>
        <DataGrid
          rows={filteredRows}
          columns={complianceColumns}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          disableColumnMenu
          checkboxSelection
          disableRowSelectionOnClick
          rowSelectionModel={rowSelectionModel}
          onRowSelectionModelChange={() => {}}
          isRowSelectable={() => false}
          rowHeight={30}
          hideFooter
          sx={{
            maxHeight: 300,
            overflowY: "auto",
            bgcolor: "#f5f5f5",
            borderTop: "none",
            borderBottom: "none",
            borderRadius: 0,
            "& .MuiDataGrid-row": {
              minHeight: "30px !important",
              maxHeight: "30px !important",
              lineHeight: "unset !important",
              opacity: 0.55,
              pointerEvents: "none",
              color: "rgba(0, 0, 0, 0.45)",
            },
            "& .MuiDataGrid-cell": {
              py: 0,
              color: "rgba(0, 0, 0, 0.45)",
            },
            "& .MuiDataGrid-columnHeaders": {
              color: "rgba(0, 0, 0, 0.5)",
            },
            "& .MuiDataGrid-checkboxInput": {
              opacity: 0.45,
              pointerEvents: "none",
            },
          }}
        />
      </Box>
      <Box
        sx={{
          backgroundColor: "#f9f9f9",
          textAlign: "center",
          padding: "10px",
          borderTop: "1px solid #e0e0e0",
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "4px",
          alignItems: "center",
          fontSize: "0.875rem",
          color: "rgba(0, 0, 0, 0.75)",
        }}
      >
        <span>If you want to add new compliances to your account, contact</span>
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          style={{
            textDecoration: "underline",
            color: "#1976d2",
            cursor: "pointer",
          }}
        >
          {SUPPORT_EMAIL}
        </a>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  const { accounts, organizations, reg_acct_error, account, loading, message } =
    state.orgAccount;
  return {
    accounts,
    organizations,
    reg_acct_error,
    account,
    loading,
    message,
    orgLicensing: state.licensing,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateOrgAccount: (data) => {
      dispatch(updateOrgAccount(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ComplianceAddons);
